import { render, staticRenderFns } from "./UserRolesTableRow.vue?vue&type=template&id=5e65e117"
import script from "./UserRolesTableRow.vue?vue&type=script&lang=js"
export * from "./UserRolesTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports